module.exports = __webpack_public_path__ + "media/images/athletes/4327-b82042bc3915f38f35a51a1f76896a6c.png";